export const DISCOVERY_STORE_ID_KEY = 'discoveryStoreId';

const normalizeStoreId = (storeId: string | null | undefined) => String(storeId || '').trim();

export const markStoreSelectedFromDiscovery = (
  storeId: string,
  storage: Storage = window.localStorage
) => {
  const normalizedStoreId = normalizeStoreId(storeId);
  if (normalizedStoreId) storage.setItem(DISCOVERY_STORE_ID_KEY, normalizedStoreId);
};

export const clearDiscoveryStoreSelection = (
  storage: Storage = window.localStorage
) => {
  storage.removeItem(DISCOVERY_STORE_ID_KEY);
};

export const isStoreSelectedFromDiscovery = (
  storeId: string | null = window.localStorage.getItem('empresaid'),
  storage: Storage = window.localStorage
) => {
  const normalizedStoreId = normalizeStoreId(storeId);
  const discoveryStoreId = normalizeStoreId(storage.getItem(DISCOVERY_STORE_ID_KEY));
  return Boolean(normalizedStoreId && discoveryStoreId === normalizedStoreId);
};
